import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_ROLE_FAILURE,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  FETCH_ALL_LIST_ROLE_FAILURE,
  FETCH_ALL_LIST_ROLE_REQUEST,
  FETCH_ALL_LIST_ROLE_SUCCESS,
  FETCH_LIST_ROLE_FAILURE,
  FETCH_LIST_ROLE_REQUEST,
  FETCH_LIST_ROLE_SUCCESS,
  FETCH_ROLE_FAILURE,
  FETCH_ROLE_REQUEST,
  FETCH_ROLE_SUCCESS,
  RESET_CURRENT_ROLE,
  UPDATE_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
} from "./roleType";

const initialState = {
  Roles: [],
  currentRole: null,
  fetchRoles: { ...defaultStatus },
  fetchAllRoles: { ...defaultStatus },
  fetchRole: { ...defaultStatus },
  addRole: { ...defaultStatus },
  updateRole: { ...defaultStatus },
  deleteRole: { ...defaultStatus },
  formMode: null, // 'add' or 'edit'
};

const RoleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // List Roles
    case FETCH_LIST_ROLE_REQUEST:
      return {
        ...state,
        fetchRoles: { ...state.fetchRoles, inProgress: true },
      };
    case FETCH_LIST_ROLE_SUCCESS:
      return {
        ...state,
        fetchRoles: {
          ...state.fetchRoles,
          success: true,
          inProgress: false,
          Roles: payload?.roles,
        },
      };
    case FETCH_LIST_ROLE_FAILURE:
      return {
        ...state,
        fetchRoles: {
          ...state.fetchRoles,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_ALL_LIST_ROLE_REQUEST: // This was the rogue block, now correctly placed as a case
        return {
          ...state,
          fetchAllRoles: { ...state.fetchAllRoles, inProgress: true },
        };
      case FETCH_ALL_LIST_ROLE_SUCCESS:
        return {
          ...state,
          fetchAllRoles: {
            ...state.fetchAllRoles,
            success: true,
            inProgress: false,
            Roles: payload?.roles,
       
          },
        };
      case FETCH_ALL_LIST_ROLE_FAILURE:
        return {
          ...state,
          fetchAllRoles: {
            ...state.fetchAllRoles,
            error: true,
            errorMessage: payload.error,
          },
        };

    // View single Role
    case FETCH_ROLE_REQUEST:
      return {
        ...state,
        fetchRole: { ...state.fetchRole, inProgress: true },
      };
    case FETCH_ROLE_SUCCESS:
      return {
        ...state,
        fetchRole: { ...state.fetchRole, success: true, inProgress: false },
        currentRole: payload.Role,
      };
    case FETCH_ROLE_FAILURE:
      return {
        ...state,
        fetchRole: {
          ...state.fetchRole,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Add Role
    case ADD_ROLE_REQUEST:
      return {
        ...state,
        addRole: { ...state.addRole, inProgress: true },
      };
    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        addRole: { ...state.addRole, success: true, inProgress: false },
        Roles: [...state.Roles, payload.Role],
        currentRole: payload.Role,
      };
    case ADD_ROLE_FAILURE:
      return {
        ...state,
        addRole: {
          ...state.addRole,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Edit Role
    case UPDATE_ROLE_REQUEST:
      return {
        ...state,
        updateRole: { ...state.updateRole, inProgress: true },
      };
    case UPDATE_ROLE_SUCCESS: {
      const updatedRole = payload.Role;
      return {
        ...state,
        updateRole: { ...state.updateRole, success: true, inProgress: false },
        Roles: state.Roles.map((Role) =>
          Role.id === updatedRole.id ? updatedRole : Role
        ),
        currentRole: updatedRole,
      };
    }
    case UPDATE_ROLE_FAILURE:
      return {
        ...state,
        updateRole: {
          ...state.updateRole,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Delete Role
    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        deleteRole: { ...state.deleteRole, inProgress: true },
      };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        deleteRole: { ...state.deleteRole, success: true, inProgress: false },
        Roles: state.Roles.filter((Role) => Role.id !== payload.RoleId),
        currentRole:
          state.currentRole?.id === payload.RoleId
            ? null
            : state.currentRole,
      };
    case DELETE_ROLE_FAILURE:
      return {
        ...state,
        deleteRole: {
          ...state.deleteRole,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Reset current Role
case RESET_CURRENT_ROLE:
  return { ...initialState }

    default:
      return state;
  }
};

export default RoleReducer;